import stripAnsi from 'strip-ansi';

// src/sanitizer.ts
var Sanitizer = class {
  #replaceNewLine;
  #replaceTab;
  constructor(options = {}) {
    this.#replaceNewLine = options.replaceNewLine ?? "\n";
    this.#replaceTab = options.replaceTab ?? "    ";
  }
  /**
   * Sanitize a string by removing ANSI escape sequences and control
   * characters, and replacing newlines/tabs per configuration.
   *
   * - ANSI escape sequences (colors, cursor codes) are stripped first
   * - Newlines and carriage returns are replaced with `replaceNewLine`
   * - Tabs are replaced with `replaceTab`
   * - Other control characters are removed
   * - Invalid Unicode replacement characters are skipped
   */
  sanitize(input) {
    const stripped = stripAnsi(input);
    let result = "";
    for (const char of stripped) {
      const code = char.codePointAt(0) ?? 0;
      if (code === 65533) {
        continue;
      }
      if (char === "\r" || char === "\n") {
        result += this.#replaceNewLine;
      } else if (char === "	") {
        result += this.#replaceTab;
      } else if (isControl(code)) ; else {
        result += char;
      }
    }
    return result;
  }
};
function isControl(code) {
  return code >= 0 && code <= 31 || code === 127 || code >= 128 && code <= 159;
}
function newSanitizer(options) {
  return new Sanitizer(options);
}

export { Sanitizer, newSanitizer };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map